import { iconsImgs } from '../../utils/icons';
import { OfferSettings, OfferSettingsView } from "../../api/enums/OfferTypes";

export default function GetOfferSetting({
  isIcon,
  option,
}: {
  isIcon: boolean;
  option: string;
}) {
  const getSetting = (settingName: string) => {
    switch (settingName) {
      case OfferSettings.IsFreeDrinks:
        return {
          icon: <img src={iconsImgs.FreeDrinks} alt="freeDrinks" />,
          text: OfferSettingsView.FreeDrinks,
        };
      case OfferSettings.IsFreeEntry:
        return {
          icon: <img src={iconsImgs.FreeEntry} alt="freeEntry" />,
          text: OfferSettingsView.FreeEntry,
        };
      case OfferSettings.IsFreeDinner:
        return {
          icon: <img src={iconsImgs.FreeDinner} alt="freeDinner" />,
          text: OfferSettingsView.FreeDinner,
        };
      case OfferSettings.IsFreeTaxi:
        return {
          icon: <img src={iconsImgs.FreeTaxi} alt="freeTaxi" />,
          text: OfferSettingsView.FreeTaxi,
        };
        case OfferSettings.IsGoodyBag:
        return {
          icon: <img src={iconsImgs.GoodyBag} alt="goodyBag" />,
          text: OfferSettingsView.IsGoodyBag,
        };
        case OfferSettings.IsOther:
        return {
          icon: <img src={iconsImgs.PreDrink} alt="preDrink" />,
          text: OfferSettingsView.IsOther,
        };
      default:
        return null;
    }
  };

  const setting = getSetting(option);

  return (
    <div>{isIcon ? setting?.icon : setting?.text}</div>
  );
}
